import { config } from "core/config/app"


export const API_LANGUAGE_UPDATE = `${config.apiPrefix}/${config.apiVersion}/auth/language-update`
export const API_VERIFY_PASSWORD = `${config.apiPrefix}/${config.apiVersion}/auth/verify-password`
export const API_CHANGE_PASSWORD = `${config.apiPrefix}/${config.apiVersion}/auth/change-password`
export const API_LEAVE_MEMBERSHIP = `${config.apiPrefix}/${config.apiVersion}/auth/leave-membership`
export const API_UPDATE_AVATAR = `${config.apiPrefix}/${config.apiVersion}/auth/update`
export const API_GET_NOTIFICATION = `${config.apiPrefix}/${config.apiVersion}/notifications`
export const API_READ_NOTIFICATION = `${config.apiPrefix}/${config.apiVersion}/notifications`
export const API_GET_BADGE_NOTIFICATION = `${config.apiPrefix}/${config.apiVersion}/notifications/unread-count`
